export default __webpack_public_path__ + "media/images/caav-c3b10110ddc4c7f577e529cd05550353.svg";